// extracted by mini-css-extract-plugin
module.exports = {"container":"e_qcb","label":"e_rcb","image":"e_scb","name":"e_tcb","description":"e_ucb","descriptionCollapsed":"e_vcb","bottomLine":"e_wcb","socialIcon":"e_xcb"};